module.exports = __webpack_public_path__ + "static/media/chief-cover-Mobile.12250225.png";